import { sharedConfig, syncSharedConfig } from './shared-config';

export const environment = {
  production: true,
  environment: 'production' as const,
  launchDarklyClientId: '643ede7c67be3b12d67ac7c1',
  smartFill: 'https://api.maximizer.com/smartfill/v1/',
  instrumentationKey: '00c46e52-bfa2-496e-be2f-1c2a2bc90131',
  oauth: {
    globalServicesKey: 'f656d2e5d3d448c192cf60d6d366e60d',
    globalServicesUrl: 'https://api.maximizer.com/cloud',
    oauth2ClientId: 'b9o5qt6y9t863u1mox9c',
    oauth2ClientIdEmea: 'xl9493py0a6igchb2fo5',
    onPremClientId: 'outlook365p1w7j8jh23',
  },
  integration: {
    syncApi: 'https://api.maximizer.com/integration/outlook',
    subscriptionKey: '01b4d72b9c094057a5af9ba185092855',
    webhookUrl: 'https://api.maximizer.com/integrations/test',
  },
  appStoreOAuthUrl:
    'https://appstoresrv.maximizer.com/appstore/midwareolsync2/index',
  appStoreConfigurationUrl:
    'https://appstoresrv.maximizer.com/appstore/midwareolsync2/configurationhandler',
  msalConfig: {
    auth: {
      clientId: '93c64b8a-0cbe-4ed8-b7c9-d4fbb603e3fe',
      authority: 'https://login.microsoftonline.com/common',
      redirectUri: 'https://outlook365.maximizer.com',
      postLogoutRedirectUri: '/',
    },
  },
  syncConfig: {
    redirectUri: 'https://outlook365.maximizer.com/sync-configuration',
    microsoft: {
      tenantId: syncSharedConfig.tenantId,
      clientId: '921a3c6f-ca28-46ca-b32d-7d293d1ade0f',
      scopes: syncSharedConfig.scopes,
    },
  },
  openAi: 'https://api.maximizer.com/ai/v1',
  integrationApp: {
    webAppUrl: 'https://api.maximizer.com/integration/maximizer-ai',
    iqBoostApiUrl: '/v1',
    subscriptionKey: '',
  },
  ...sharedConfig,
};
